import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentoAccredito, Evento } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-documenti-accrediti-backoffice',
  templateUrl: './documenti-accrediti-backoffice.component.html',
  styleUrls: ['./documenti-accrediti-backoffice.component.css']
})
export class DocumentiAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;

  @Input() documenti: DocumentoAccredito[] = [];  
  @Input() evento?: Evento;

  documento?: DocumentoAccredito;
  documentiSorted: DocumentoAccredito[] = [];

  loading: boolean = false;

  private notaDraft = new Map<number, string>();

  ngOnChanges(changes: SimpleChanges): void {
    this.documenti = changes['documenti']?.currentValue || this.documenti;    
    this.evento = changes['evento']?.currentValue || this.evento;
    if (changes['documenti']) this.sortDocumenti();
  }

  /** Non-verde prima, accettato in fondo. */
  private sortDocumenti() {
    const rank = (s?: string) => {
      if (s === 'non accettato') return 0;
      if (s === 'ok' || !s) return 1;
      if (s === 'accettato') return 2;
      return 1;
    };
    this.documentiSorted = [...(this.documenti || [])].sort((a, b) => rank(a.stato) - rank(b.stato));
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDocumento(file: string) {
    this.apiService.openProtectedFile(file);
  }

  labelSubappalto(documento: DocumentoAccredito): string {
    if (documento.subappalto) return documento.subappalto;
    const id = documento.id_subappalto;
    if (!id) return '';
    const s = (this.evento?.subappalti || []).find(x => Number(x.id) === Number(id));
    return s?.ragione_sociale || '';
  }

  onOpenDelete(event: Event, documento: DocumentoAccredito, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento?`,
      reject: () => this.confirmationService.close(),
      accept: () => {        
        this.apiService.deleteDocumentoAccredito(documento.id).subscribe({
          next: (data) => this.apiService.setDocumentiEvento(this.evento!.id),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il documento è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }

  onZip() {
    this.loading = true;
    this.apiService.getZipDocumenti(this.documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  onStato(stato: string, documento: DocumentoAccredito) {
    const next = documento.stato === stato ? 'ok' : stato;
    this.loading = true;
    this.apiService.updateStatoDocumento(next, documento.id).subscribe({
      next: () => {
        documento.stato = next;
        this.sortDocumenti();
        if (this.evento?.id) this.apiService.documentoStatoChanged.next(this.evento.id);
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onNotaDraft(documento: DocumentoAccredito, value: string) {
    this.notaDraft.set(documento.id, value);
  }

  onNotaBlur(documento: DocumentoAccredito) {
    const note = this.notaDraft.has(documento.id) ? this.notaDraft.get(documento.id)! : (documento.note || '');
    if (note === (documento.note || '')) return;
    this.apiService.updateNotaDocumento(note || null, documento.id).subscribe({
      next: () => {
        documento.note = note;
        this.apiService.message('success', 'Note', 'Nota aggiornata');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message),
    });
  }
}
